var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrice = function SvgPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.32017L9.05256 1L7.16008 3.61702L3.94744 3.94744L3.61702 7.16008L1 9.05256L2.32017 12L1 14.9474L3.61702 16.8399L3.94744 20.0526L7.16008 20.383L9.05256 23L12 21.6798L14.9474 23L16.8399 20.383L20.0526 20.0526L20.383 16.8399L23 14.9474L21.6798 12L23 9.05256L20.383 7.16008L20.0526 3.94744L16.8399 3.61702L14.9474 1L12 2.32017ZM9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11ZM16 14.5C16 15.3284 15.3284 16 14.5 16C13.6716 16 13 15.3284 13 14.5C13 13.6716 13.6716 13 14.5 13C15.3284 13 16 13.6716 16 14.5ZM14.5844 8L8 14.5844L9.41557 16L16 9.41557L14.5844 8Z",
    fill: "currentColor"
  })));
};
export default SvgPrice;